type ConditionalRenderProps = {
    condition: boolean;
    children: React.ReactNode;
    accessibilityLabel?: string;
};

export const ConditionalRender = ({
    condition,
    children,
    accessibilityLabel,
}: ConditionalRenderProps) =>
    condition ? <div aria-label={accessibilityLabel}>{children}</div> : null;
